export default "__VITE_ASSET__B6nGzC9T__"